/**
 * @generated SignedSource<<40e2b37836ef7625e634b9236789b118>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export enum SitePermissionTypeFilter {
  ALL = "ALL",
  EXTERNALCOLLABORATOR = "EXTERNALCOLLABORATOR",
  NONE = "NONE",
}
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous =
  {
    __typename?: "Anonymous";
    type: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous_profilePicture_Icon | null;
  };
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    type: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous_profilePicture_Icon | null;
  };
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_UnknownUser =
  {
    __typename?: "UnknownUser";
    type: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous_profilePicture_Icon | null;
  };
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_User =
  {
    __typename?: "User";
    type: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous_profilePicture_Icon | null;
  };
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users =

    | UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_Anonymous
    | UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_KnownUser
    | UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_UnknownUser
    | UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users_User;
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_groups_Group =
  {
    __typename?: "Group";
    id: string | null;
    name: string | null;
    permissionType: SitePermissionType | null;
  };
export type UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults =
  {
    __typename?: "GraphQLUserAndGroupSearchResults";
    users?: Array<UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_users | null>;
    groups?: Array<UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults_groups_Group | null>;
  };
export type UserAndGroupSearchQuery_Query = {
  __typename?: "Query";
  userGroupSearch: UserAndGroupSearchQuery_userGroupSearch_GraphQLUserAndGroupSearchResults | null;
};
export type UserAndGroupSearchQueryVariables = Exact<{
  searchTerm: Scalars["String"]["input"];
  maxResults?: InputMaybe<Scalars["Int"]["input"]>;
  withGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
  withUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  sitePermissionTypeFilter?: InputMaybe<SitePermissionTypeFilter>;
}>;
export type UserAndGroupSearchQuery = UserAndGroupSearchQuery_Query;
